import type { DataResponseBody, PageResponse, FileResponse } from "./common.types";

export type SiteRegion =
  | "SEOUL"
  | "GYEONGGI_INCHEON"
  | "GANGWON"
  | "CHUNGCHEONG"
  | "JEOLLA"
  | "GYEONGSANG"
  | "JEJU";

export const REGION_DISPLAY_NAMES: Record<SiteRegion, string> = {
  SEOUL: "서울",
  GYEONGGI_INCHEON: "경기/인천",
  GANGWON: "강원",
  CHUNGCHEONG: "충청",
  JEOLLA: "전라",
  GYEONGSANG: "경상",
  JEJU: "제주",
};

export interface Site {
  id: number;
  name: string;
  region: SiteRegion;
  address?: string;
  /** 경도 — #11 마이그레이션으로 longitude → lon */
  lon?: number;
  /** 위도 — #11 마이그레이션으로 latitude → lat */
  lat?: number;
  /**
   * @deprecated 백엔드 응답에서 제거됨. mocks와 MapboxViewer가 의존 중이라 옵셔널로 유지.
   * #30 (Mapbox → 3D viewer 전환) PR에서 함께 제거 예정.
   */
  location?: string;
  baseUrl?: string;
  constructionStartDate?: string;
  constructionEndDate?: string;
  description?: string;
  /** 백엔드 응답은 FileResponse 객체. 본 타입 정확화는 후속 이슈에서 */
  thumbnailImage?: unknown;
  /** 3D 모델 파일 (GLB/GLTF). 3D 뷰어는 modelFile.url 을 로드. admin에서 업로드. */
  modelFile?: FileResponse;
  /** 모델 하이라키 + 층별 공정 일정 (stringified JSON, @safers/model ModelHierarchyDoc). */
  modelHierarchy?: string | null;
}

export interface RegionResponse {
  name: SiteRegion;
  displayName: string;
}

export interface RegionGroup {
  region: SiteRegion;
  displayName: string;
  sites: Site[];
}

export type SitesResponse = DataResponseBody<PageResponse<Site>>;
export type SiteResponse = DataResponseBody<Site>;
export type RegionsResponse = DataResponseBody<RegionResponse[]>;

export interface GetSitesParams {
  region?: SiteRegion;
  page?: number;
  size?: number;
}
